/* eslint-disable */
import {
  makeStyles,
  RACBadge,
  RACBreadcrumb,
  RACBreadcrumbLinkType,
  Typography,
} from '@rentacenter/racstrap';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState } from 'react';
import { ApiStateWrapper } from '../../common/ApiStateWrapper/ApiStateWrapper';
import { AppRoute } from '../../config/route-config';
import { DATE_FORMAT, getVerificationString } from '../../constants/constants';
import { useCustomerDetails } from '../../context/CustomerDetails/CustomerDetailsProvider';
import { PastDueCustomerResponse } from '../../domain/PastDueList/PastDueCustomerList';
import { formatDateString, formatMoney } from '../../utils/utils';
import { useStoreDetails } from '../../context/Store/StoreProvider';
import { useTranslation } from 'react-i18next';
import { ReactComponent as GoldBadge } from "../../assets/img/gold.svg"
import { ReactComponent as PlatinumBadge } from "../../assets/img/platinum.svg"
import { ReactComponent as DiamondBadge } from "../../assets/img/diamond.svg"

import { useHistory } from 'react-router-dom';
export interface CustomerProps {
  customer?: PastDueCustomerResponse;
}

const useStyles = makeStyles((theme: any) => ({
  contentHeight: {
    position: 'absolute',
    height: '100vh',
    width: '100%',
  },
  row: {
    display: 'flex',
    width: '100%',
  },
  breadcrumbContainer: {
    width: '100%',
    height: theme.typography.pxToRem(45),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  deInfoContainer: {
    right: 0,
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    gap: theme.typography.pxToRem(40),
  },
  deInfo: {
    color: '#2179FE',
  },
  deStatusDetail: {
    paddingTop: theme.typography.pxToRem(8),
  },
  approvalExpiryInfo: {
    color: '#5b6d83',
  },
  levelBadgeBase: {
    color: 'white',
    borderRadius: '11px',
    float: 'left' as const,
    padding: '5px 10px',
    fontSize: '0.75em',
    fontWeight: 700,
    lineHeight: 1,
    textAlign: 'center' as const,
    whiteSpace: 'nowrap' as const,
    verticalAlign: 'baseline' as const,
  },
  levelBadgeDeReviewPending: {
    backgroundColor: 'rgb(253 180 13)',
  },
}));

export const initialLinks = [
  {
    href: `${AppRoute.Index}`,
    label: 'Dashboard',
  },
  {
    href: `${AppRoute.PastDueList}`,
    label: 'Past Due List',
  },
];

export const initialLinksM = [
  {
    href: `${AppRoute.Dashboard}`,
    label: 'Dashboard',
  },
  {
    href: `${AppRoute.PastDueList}`,
    label: 'Past Due List',
  },
];

const getLinks = () => {
  if (window.location.pathname.includes('menu')) {
    return initialLinksM;
  }
  return initialLinks;
};
const getCustomerPath = (customerId: any) => {
  if (window.location.pathname.includes('menu')) {
    // return `/menu/customer/update/${customerId}/customer`;
    return `/customer/update/${customerId}/customer`;
  }
  return '/am/customer/' + customerId;
};

export const CustomerBreadcrumb = () => {
  const { t } = useTranslation();

  const ownClasses = useStyles();
  const [links, setLinks] =
    React.useState<RACBreadcrumbLinkType[]>(initialLinks);
  const linkLable = links.map((link) => ({
    ...link,
    label: t(`${link.label}`),
  }));
  const {
    customerDetails,
    loading,
    hasApiError,
    customerApprovalDetailsResp,
    customerApprovalLabel,
    customerVerificationLabel,
    getCustomerResponse,
    customerTierDetails,
  } = useCustomerDetails();

  const { isMXAccountManagement } = useStoreDetails();
  const [lastValidCustomerData, setLastValidCustomerData] = useState(null);
  useEffect(() => {
    if (getCustomerResponse?.GetCustomer?.value &&
      getCustomerResponse?.GetApproval?.value?.customerApprovalDetails) {
      setLastValidCustomerData(getCustomerResponse);
    }
  }, [getCustomerResponse]);

  const memoizedCustomerResponse = useMemo(() => {
    if (lastValidCustomerData &&
      (!getCustomerResponse?.GetCustomer?.value ||
        !getCustomerResponse?.GetApproval?.value?.customerApprovalDetails)) {
      return lastValidCustomerData;
    }
    return getCustomerResponse;
  }, [getCustomerResponse, lastValidCustomerData]);

  const { customerVerificationOptimization, enableCustomerTierReward } = useStoreDetails();
  const [showLevels, setShowLevels] = useState(false);
  const { firstName, lastName, customerId, verifiedDate } =
    customerDetails || {};
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    if (!customerDetails) return;
    const links = getLinks();
    const label =
      firstName && lastName && customerId
        ? `${firstName || ''} ${lastName || ''} - ${customerId || ''}`
        : '';
    setLinks([
      ...links,
      {
        href: `${getCustomerPath(customerId)}`,
        label: label,
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDetails]);
  const handleOnclick = () => {
    /* eslint-disable no-console */
    console.log('OnClick');
  };
  const customerDetailLoaded =
    loading !== undefined && !loading && !hasApiError;

  const approvalExpirationDate = formatDateString(
    customerApprovalDetailsResp?.customerApprovalDetails
      ?.approvalExpirationDate,
    DATE_FORMAT
  );
  const verificationExpirationDate = formatDateString(
    verifiedDate,
    DATE_FORMAT
  );
  const handleClick = (event: any, href: string) => {
    history.push(href);
  };
  const handleBadgeClick = () => {
    history.push(`/customer/update/${customerId}/customer`,
      { openRewardsTab: true })
  }

  console.log('New Log', customerVerificationOptimization, getCustomerResponse, customerTierDetails);

  return (
    <>
      <ApiStateWrapper
        loading={loading}
        hasApiError={hasApiError}
        successContent={<></>}
        classes={{
          loader: ownClasses.contentHeight,
          apiError: ownClasses.contentHeight,
        }}
      />
      {customerDetailLoaded && (
        <div className={classes.row}>
          <div className={clsx(classes.breadcrumbContainer)}>
            <RACBreadcrumb links={linkLable} onClick={handleClick} />
            {customerTierDetails?.memberTiers &&
              customerTierDetails?.memberTiers?.loyaltyMemberTier &&
              ['gold', 'platinum', 'diamond'].includes(customerTierDetails.memberTiers.loyaltyMemberTier.toLowerCase()) 
              && enableCustomerTierReward == '1' && customerTierDetails?.memberStatus == 'Active' &&  (
                <>
                  {(() => {
                    const tier = customerTierDetails?.memberTiers?.loyaltyMemberTier.toLowerCase();
                    switch (tier) {
                      case 'gold':
                        return <GoldBadge
                          style={{
                            height: '19px',
                            width: 'auto',
                            marginLeft: '8px',
                            verticalAlign: 'middle',
                            cursor: 'pointer'
                          }}
                          title="Gold Tier Member"
                          onClick={handleBadgeClick}
                        />;
                      case 'platinum':
                        return <PlatinumBadge
                          style={{
                            height: '19px',
                            width: 'auto',
                            marginLeft: '8px',
                            verticalAlign: 'middle',
                            cursor: 'pointer'
                          }}
                          title="Platinum Tier Member"
                          onClick={handleBadgeClick}
                        />;
                      case 'diamond':
                        return <DiamondBadge
                          style={{
                            height: '19px',
                            width: 'auto',
                            marginLeft: '8px',
                            verticalAlign: 'middle',
                            cursor: 'pointer'
                          }}
                          title="Diamond Tier Member"
                          onClick={handleBadgeClick}
                        />;
                      default:
                        return null;
                    }
                  })()}
                </>
              )}
            <div className={classes.deInfoContainer}>
              <div className={classes.deInfo}>
                <div className={classes.row}>
                  <Typography display="inline" variant="body1">
                    {t('Approval Amount :')}{' '}
                  </Typography>
                </div>
                <div className={classes.row}>
                  <Typography display="inline" variant="body1">
                    {formatMoney(
                      customerApprovalDetailsResp?.customerApprovalDetails
                        ?.approvalAmount
                    )}
                  </Typography>
                </div>
              </div>

              <div className={classes.deInfo}>
                <div className={classes.row}>
                  <Typography display="inline" variant="body1">
                    {t('Weekly Approval Amount :')}{' '}
                  </Typography>
                </div>
                <div className={classes.row}>
                  <Typography display="inline" variant="body1">
                    {formatMoney(
                      customerApprovalDetailsResp?.customerApprovalDetails
                        ?.weeklyApprovalAmount
                    )}
                  </Typography>
                </div>
              </div>
              <div className={classes.deStatusDetail}>
                <div className={classes.row}>
                  {customerVerificationOptimization ? (
                    <>
                      {memoizedCustomerResponse &&
                        memoizedCustomerResponse?.GetCustomer?.value &&
                        memoizedCustomerResponse?.GetApproval?.value
                          ?.customerApprovalDetails &&
                        (memoizedCustomerResponse?.GetApproval?.value
                          ?.customerApprovalDetails?.verifyCode == '1' ||
                          memoizedCustomerResponse?.GetApproval?.value
                            ?.customerApprovalDetails?.verifyCode == '-1' ||
                          memoizedCustomerResponse?.GetApproval?.value
                            ?.customerApprovalDetails?.verifyCode == '0' ||
                          memoizedCustomerResponse?.GetApproval?.value
                            ?.customerApprovalDetails?.verifyCode == null) ? (
                        <>
                            <span
                              style={{
                                backgroundColor: '#bb37ae',
                                color: 'white',
                                borderRadius: '11px',
                                marginRight:
                                  memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verificationStatus == 'NOTREQUIRED'
                                    ? '-35px'
                                    : memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.approvalStatus == 'D' &&
                                      memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyLevel == -1
                                      ? '-33px'
                                      : '6px',
                                float: 'left',
                                padding: '5px 10px',
                                fontSize: '0.75em',
                                fontWeight: 700,
                                lineHeight: 1,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'baseline',
                              }}
                            >
                              {(memoizedCustomerResponse?.GetCustomer?.value?.salesLeadId ||
                                memoizedCustomerResponse?.GetCustomer?.value?.createdBy == 'EC' ||
                                memoizedCustomerResponse?.GetCustomer?.value?.createdBy == 'ECOM') &&
                                (memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == '-1' ||
                                  memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == null)
                                ? t('Previous-Web')
                                : (memoizedCustomerResponse?.GetCustomer?.value?.salesLeadId ||
                                  memoizedCustomerResponse?.GetCustomer?.value?.createdBy == 'EC' ||
                                  memoizedCustomerResponse?.GetCustomer?.value?.createdBy == 'ECOM') &&
                                  (memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == '0' ||
                                    memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == '1')
                                  ? t('New-Web')
                                  : memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == '-1' ||
                                    memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyCode == null
                                    ? t('Previous')
                                    : t('New')}
                            </span>
                        </>
                      ) : null}
                      {/* Customer type binding end */}

                      {/* Verification Level badge start*/}
                      {memoizedCustomerResponse?.GetApproval?.value
                        ?.customerApprovalDetails?.verifyLevel &&
                        memoizedCustomerResponse?.GetApproval?.value
                          ?.customerApprovalDetails?.verificationStatus ==
                        t('COMPLETED') ? (
                        <span
                          style={{
                            backgroundColor: '#0d6efd',
                            color: 'white',
                            borderRadius: '11px',
                            marginRight: '-35px',
                            float: 'left',
                            padding: '5px 10px',
                            fontSize: '0.75em',
                            fontWeight: 700,
                            lineHeight: 1,
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            verticalAlign: 'baseline',
                          }}
                        >
                          {memoizedCustomerResponse?.GetApproval?.value
                            ?.customerApprovalDetails?.verifyLevel == -1
                            ? t('Verified')
                            : `${t('Level')} ${memoizedCustomerResponse?.GetApproval?.value
                              ?.customerApprovalDetails?.verifyLevel} - ${t('Verified')}`}
                        </span>
                      ) : memoizedCustomerResponse?.GetApproval?.value
                        ?.customerApprovalDetails?.verificationStatus ==
                        t('PENDING') ? (
                        memoizedCustomerResponse?.GetApproval?.value
                          ?.customerApprovalDetails?.verifyLevel != -1 ? (
                        <span style={{ position: 'relative' }}>
                          <span
                            onMouseOver={() => {
                              setShowLevels(true);
                            }}
                            onMouseOut={() => {
                              setShowLevels(false);
                            }}
                            style={{
                              backgroundColor: '#e85c5c',
                              color: 'white',
                              borderRadius: '11px',
                              marginRight:
                                memoizedCustomerResponse?.GetApproval?.value
                                  ?.customerApprovalDetails?.approvalStatus ==
                                  'A' ||
                                  memoizedCustomerResponse?.GetApproval?.value
                                    ?.customerApprovalDetails?.approvalStatus ==
                                  'M'
                                  ? '-30px'
                                  : '13px',
                              float: 'left',
                              padding: '5px 10px',
                              fontSize: '0.75em',
                              fontWeight: 700,
                              lineHeight: 1,
                              textAlign: 'center',
                              whiteSpace: 'nowrap',
                              verticalAlign: 'baseline',
                              cursor: 'pointer',
                            }}
                          >
                            {memoizedCustomerResponse?.GetApproval?.value
                              ?.customerApprovalDetails?.verifyLevel &&
                              memoizedCustomerResponse?.GetApproval?.value
                                ?.customerApprovalDetails?.verificationStatus !=
                              t('COMPLETED')
                                ? `Level ${memoizedCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyLevel} `
                              : t('Verified')}
                          </span>
                          {showLevels && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '0px',
                                right:
                                  memoizedCustomerResponse?.GetApproval?.value
                                    ?.customerApprovalDetails?.verifyLevel == 1
                                    ? '-200px'
                                    : memoizedCustomerResponse?.GetApproval?.value
                                      ?.customerApprovalDetails
                                      ?.verifyLevel == 2
                                      ? '-265px'
                                      : '-302px',
                                transform: 'translateX(-50%)',
                                marginBottom: '20px',
                                backgroundColor: '#e9f1f6',
                                color: 'black',
                                padding: '5px',
                                borderRadius: '10px',
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                zIndex: 2000,
                                fontWeight: 'bold',
                              }}
                            >
                              {memoizedCustomerResponse?.GetApproval?.value
                                ?.customerApprovalDetails
                                ? getVerificationString(
                                  memoizedCustomerResponse?.GetApproval?.value
                                    ?.customerApprovalDetails
                                )
                                : ''}
                            </div>
                          )}
                        </span>
                        ) : null
                      ) : memoizedCustomerResponse?.GetApproval?.value
                        ?.customerApprovalDetails?.verifyLevel &&
                        memoizedCustomerResponse?.GetApproval?.value
                          ?.customerApprovalDetails?.verificationStatus ==
                        t('REVIEW PENDING') ? (
                        <span
                          style={{
                            backgroundColor: 'rgb(253 180 13)',
                            color: 'white',
                            borderRadius: '11px',
                            marginRight: '-30px',
                            float: 'left',
                            padding: '5px 10px',
                            fontSize: '0.75em',
                            fontWeight: 700,
                            lineHeight: 1,
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            verticalAlign: 'baseline',
                          }}
                        >
                          {memoizedCustomerResponse?.GetApproval?.value
                            ?.customerApprovalDetails?.verifyLevel == -1
                            ? t('Review Pending')
                            : `${t('Level')} ${memoizedCustomerResponse?.GetApproval?.value
                              ?.customerApprovalDetails?.verifyLevel} - ${t('Review Pending')}`}
                        </span>
                      ) : null}

                      {/* Verification Level badge end line  */}
                    </>
                  ) : (
                    <RACBadge
                      TextValue={customerVerificationLabel.text}
                      backgroundColor={customerVerificationLabel.bgColor}
                      color="white"
                      OnclickNeed={false}
                      handleOnClick={handleOnclick}
                    />
                  )}
                </div>
                {!customerVerificationOptimization &&
                  customerVerificationLabel.showExpiryDate && (
                    <div className={classes.row}>
                      <div className={classes.approvalExpiryInfo}>
                        <Typography display="inline" variant="body1">
                          {t('Expires on')}{' '}
                        </Typography>
                        <Typography display="inline" variant="body1">
                          {verificationExpirationDate}
                        </Typography>
                      </div>
                    </div>
                  )}
              </div>
              {!isMXAccountManagement?(<div className={classes.deStatusDetail}>
                <div className={classes.row} style={{ gap: '8px' }}>
                  {'verifyLevel' in (customerApprovalDetailsResp?.customerApprovalDetails || {}) &&
                  customerApprovalDetailsResp?.customerApprovalDetails?.verifyLevel === null && (
                    <span
                      className={`${classes.levelBadgeBase} ${classes.levelBadgeDeReviewPending}`}
                    >
                      {t('DE Review Pending')}
                    </span>
                  )}
                  <RACBadge
                    TextValue={customerApprovalLabel.text}
                    backgroundColor={customerApprovalLabel.bgColor}
                    color="white"
                    OnclickNeed={false}
                    handleOnClick={handleOnclick}
                  />
                </div>
                {customerApprovalLabel.showExpiryDate && (
                  <div className={classes.row}>
                    <div className={classes.approvalExpiryInfo}>
                      <Typography display="inline" variant="body1">
                        {t('Expires on')}{' '}
                      </Typography>
                      <Typography display="inline" variant="body1">
                        {approvalExpirationDate}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>):(<></>)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
